export class User {
  isAdmin?: boolean;
  street?: string;
  apartment?: string;
  zip?: string;
  city?: string;
  country?: string;
  id?: string;
  name?: string;
  email?: string;
  phone?: number;
  password?: string;
  token?: string;
}
